import { ApiResponse } from '@shared/utils/api-response'
import { Check } from '../types/check'
import { NextTableMetaResponse } from '@shared/modules/next-table/types'
import { urlMaker } from '@shared/utils/url-maker'
import { caller } from '@shared/utils/caller'
import { CashRegisterMapper } from '../mappers'
import { nextTableMetaMapper } from '@shared/modules/next-table/utils/meta-mapper'

export class CashRegisterChecksService {
  public static async getAll(
    query?: Record<string, any>,
  ): Promise<ApiResponse<200, Check[], NextTableMetaResponse> | ApiResponse<400 | 500, string>> {
    const url = urlMaker('/api/device/cheques', query)

    try {
      const response = await caller(url)

      if (response.ok) {
        const { data, ...meta } = await response.json()
        return new ApiResponse(200, CashRegisterMapper.Checks.manyFromApi(data), nextTableMetaMapper(meta))
      } else {
        return new ApiResponse(400, 'Məlumatlar əldə edilə bilmədi', null)
      }
    } catch (e) {
      return new ApiResponse(500, 'Şəbəkə ilə əlaqə qurula bilmədi', null)
    }
  }

  public static async print(id: number | string): Promise<ApiResponse<200> | ApiResponse<400 | 500, string>> {
    const url = urlMaker('/api/device/printCheque', { cheque_id: id })
    try {
      const response = await caller(url, { method: 'POST' })

      if (response.ok) {
        return new ApiResponse(200, null, null)
      } else if (response.status === 400 || response.status === 422) {
        const { errors } = await response.json()
        return new ApiResponse(400, Object.values(errors).join('. '), null)
      } else {
        return new ApiResponse(400, 'Əməliyyat aparıla bilmədi', null)
      }
    } catch (e) {
      return new ApiResponse(500, 'Şəbəkə ilə əlaqə qurula bilmədi', null)
    }
  }

  public static async printLast(): Promise<ApiResponse<200> | ApiResponse<400 | 500, string>> {
    const url = urlMaker('/api/device/printLastCheque')
    try {
      const response = await caller(url, { method: 'POST' })

      if (response.ok) {
        return new ApiResponse(200, null, null)
      } else if (response.status === 400 || response.status === 422) {
        const { errors } = await response.json()
        const mappedErrors = Object.values<string[]>(errors).flat().join(', ')
        return new ApiResponse(400, mappedErrors, null)
      } else {
        return new ApiResponse(400, 'Əməliyyat aparıla bilmədi', null)
      }
    } catch (e) {
      return new ApiResponse(500, 'Şəbəkə ilə əlaqə qurula bilmədi', null)
    }
  }

  public static async refund(id: number | string): Promise<ApiResponse<200> | ApiResponse<400 | 500, string>> {
    const url = urlMaker('/api/device/moneyback', { cheque_id: id })
    try {
      const response = await caller(url, { method: 'POST' })

      if (response.ok) {
        return new ApiResponse(200, null, null)
      } else {
        return new ApiResponse(400, 'Əməliyyat aparıla bilmədi', null)
      }
    } catch (e) {
      return new ApiResponse(500, 'Şəbəkə ilə əlaqə qurula bilmədi', null)
    }
  }

  public static async remove(ids: (number | string)[]): Promise<ApiResponse<200> | ApiResponse<400 | 500, string>> {
    const url = urlMaker('/api/device/chequeremove', { cheque_id: ids })
    try {
      const response = await caller(url, { method: 'POST' })

      if (response.ok) {
        return new ApiResponse(200, null, null)
      } else {
        return new ApiResponse(400, 'Əməliyyat aparıla bilmədi', null)
      }
    } catch (e) {
      return new ApiResponse(500, 'Şəbəkə ilə əlaqə qurula bilmədi', null)
    }
  }

  public static async export(query: Record<string, any>): Promise<ApiResponse<200, any> | ApiResponse<400 | 500, string>> {
    try {
      const url = urlMaker('/api/device/cheques/export', query)
      const response = await caller(url)
      if (response.ok) {
        const blob = await response.blob()
        return new ApiResponse(200, blob, null)
      } else {
        if (response.status === 400 || response.status === 422) {
          const { errors } = await response.json()
          const message = Object.values(errors).flat().join(', ')
          return new ApiResponse(500, message || 'Əməliyyat aparıla bilmədi', null)
        }
        return new ApiResponse(500, 'Əməliyyat aparıla bilmədi', null)
      }
    } catch (e) {
      return new ApiResponse(500, 'Əməliyyat aparıla bilmədi', null)
    }
  }
}
